// Helper function to estimate read time
export function estimateReadTime(body?: any[]): number {
  if (!body) return 0;

  // Count words in the body
  const text = body
    .filter((block) => block._type === 'block')
    .map(
      (block) =>
        block.children?.map((child: any) => child.text).join(' ') || '',
    )
    .join(' ');

  const wordCount = text.split(/\s+/).length;
  const wordsPerMinute = 200;
  const readTime = Math.ceil(wordCount / wordsPerMinute);

  return readTime || 1;
}
